// Test IDs for the registration-completion flow (05.2) and the minimal
// protected route reached after a successful registration.

export const REGISTRATION = {
        page: 'registration-page',
        loading: 'registration-loading',
        error: 'registration-error',
        contextInfo: 'registration-context-info',
        emailInput: 'registration-email-input',
        passwordInput: 'registration-password-input',
        passwordConfirmInput: 'registration-password-confirm-input',
        submitButton: 'registration-submit-button',
        formError: 'registration-form-error',
};

export const APP_HOME = {
        page: 'app-home-page',
        welcome: 'app-home-welcome',
        status: 'app-home-status',
        unauth: 'app-home-unauth',
        loading: 'app-home-loading',
        logoutButton: 'app-home-logout-button',
};

export const LOGIN_FORM = {
        page: 'login-page',
        numberInput: 'login-number-input',
        passwordInput: 'login-password-input',
        rememberCheckbox: 'login-remember-checkbox',
        submitButton: 'login-submit-button',
        formError: 'login-form-error',
        // MS-L6B — banner shown after a successful account deletion request
        deletionRequestedBanner: 'login-deletion-requested-banner',
};

export const DASHBOARD = {
        shell: 'dashboard-shell',
        loading: 'dashboard-loading',
        logout: 'dashboard-logout',
        navHome: 'dashboard-nav-home',
        navLavori: 'dashboard-nav-lavori',
        navPreventivi: 'dashboard-nav-preventivi',
        navImpostazioni: 'dashboard-nav-impostazioni',
        placeholder: 'dashboard-placeholder',
        home: 'dashboard-home',
        globalEmpty: 'home-global-empty',
        activeJobs: 'home-active-jobs',
        activeJobsEmpty: 'home-active-jobs-empty',
        quotesToConfirm: 'home-quotes-to-confirm',
        quotesToConfirmEmpty: 'home-quotes-to-confirm-empty',
        recentExtras: 'home-recent-extras',
        recentExtrasEmpty: 'home-recent-extras-empty',
        installSuggestion: 'home-install-suggestion',
        installSuggestionInstall: 'home-install-suggestion-install',
        installSuggestionDismiss: 'home-install-suggestion-dismiss',
        installSuggestionClose: 'home-install-suggestion-close',
        installSuggestionIosHint: 'home-install-suggestion-ios-hint',
        legalFooter: 'dashboard-legal-footer',
        legalPrivacyLink: 'dashboard-legal-privacy',
        legalTermsLink: 'dashboard-legal-terms',
};

export const JOBS = {
        list: 'jobs-list',
        listEmpty: 'jobs-list-empty',
        item: 'jobs-list-item',
        detail: 'job-detail',
        back: 'job-detail-back',
        lavoroSummary: 'job-lavoro-summary',
        editDescriptionBtn: 'job-edit-description-btn',
        editNotesBtn: 'job-edit-notes-btn',
        editInput: 'job-edit-input',
        editSave: 'job-edit-save',
        editCancel: 'job-edit-cancel',
        items: 'job-items',
        media: 'job-media',
        quote: 'job-quote',
        quoteLink: 'job-quote-link',
        variations: 'job-variations',
        audit: 'job-audit',
        complete: 'job-complete-btn',
        archive: 'job-archive-btn',
        dismiss: 'job-dismiss-btn',
        restore: 'job-restore-btn',
        dismissConfirm: 'job-dismiss-confirm-btn',
        dismissCancel: 'job-dismiss-cancel-btn',
};

export const QUOTES = {
        list: 'quotes-list',
        listEmpty: 'quotes-list-empty',
        item: 'quotes-list-item',
        detail: 'quote-detail',
        back: 'quote-detail-back',
        jobLink: 'quote-job-link',
        versions: 'quote-versions',
        versionItem: 'quote-version-item',
        pdfPreview: 'quote-pdf-preview',
        pdfDownload: 'quote-pdf-download',
        confirm: 'quote-confirm-btn',
        cancel: 'quote-cancel-btn',
        vatToggle: 'quote-vat-panel-toggle',
        vatApplied: 'quote-vat-applied',
        vatRate: 'quote-vat-rate',
        vatMode: 'quote-vat-mode',
        vatPreview: 'quote-vat-preview-btn',
        vatPreviewResult: 'quote-vat-preview-result',
        vatConfirm: 'quote-vat-confirm-btn',
        dismiss: 'quote-dismiss-btn',
        restore: 'quote-restore-btn',
        dismissConfirm: 'quote-dismiss-confirm-btn',
        dismissCancel: 'quote-dismiss-cancel-btn',
};

export const SETTINGS = {
        page: 'settings-page',
        profileName: 'settings-business-name',
        profileLegal: 'settings-legal-name',
        profileVat: 'settings-vat-number',
        profileContact: 'settings-contact-info',
        profileAddress: 'settings-address-cap',
        profilePhone: 'settings-phone',
        profileHeader: 'settings-header-note',
        profileNotes: 'settings-standard-notes',
        profileSave: 'settings-profile-save',
        logoInput: 'settings-logo-input',
        fiscalApplied: 'settings-fiscal-applied',
        fiscalRate: 'settings-fiscal-rate',
        fiscalMode: 'settings-fiscal-mode',
        fiscalSave: 'settings-fiscal-save',
        accountWhatsapp: 'settings-account-whatsapp',
        accountEmail: 'settings-account-email',
        accountEmailSave: 'settings-account-email-save',
        pwCurrent: 'settings-pw-current',
        pwNew: 'settings-pw-new',
        pwSave: 'settings-pw-save',
        toast: 'settings-toast',
        installCard: 'settings-install-card',
        installButton: 'settings-install-button',
        installIosHint: 'settings-install-ios-hint',
        installStatusInstalled: 'settings-install-installed',
        installStatusNeutral: 'settings-install-neutral',
        // MS-L6B — Pre-Beta account deletion request
        accountDeleteButton: 'settings-account-delete-button',
        accountDeleteConfirm1Dialog: 'settings-account-delete-confirm-1-dialog',
        accountDeleteConfirm1: 'settings-account-delete-confirm-1',
        accountDeleteConfirm1Cancel: 'settings-account-delete-confirm-1-cancel',
        accountDeleteConfirmFinalDialog: 'settings-account-delete-confirm-final-dialog',
        accountDeleteConfirmFinal: 'settings-account-delete-confirm-final',
        accountDeleteConfirmFinalCancel: 'settings-account-delete-confirm-final-cancel',
};
